import { selectors, useDispatch, useSelector } from '@sloyd/store-base';
import { useMemo } from 'react';
import { invokeEvent } from 'shared-base';
import { ContentMaterialStudio } from './ContentMaterialStudio';

export type ContentMaterialStudioContainerProps = {};

export function ContentMaterialStudioContainer(_props: ContentMaterialStudioContainerProps) {
  const dispatch = useDispatch();
  const appState = useSelector(selectors.raw.$rawAppState);

  const callbacks = useMemo(
    () => ({
      onAnimate: () => {
        invokeEvent('nav', { path: 'labs/three' });
      },
      onPrompt(prompt: string) {
        dispatch({ type: 'STUDIO', verb: 'textaco', payload: { prompt } });
      },
    }),
    []
  );

  return <ContentMaterialStudio callbacks={callbacks} />;
}

export default ContentMaterialStudioContainer;
